<template>
  <!-- Without `w-full` the stage's centring shrinks this to the text. -->
  <div class="grid w-full place-items-center gap-24">
    <p class="max-w-[48ch] text-balance">
      {{ i18n(body) }}
    </p>
    <AmbientVideo :sources="sourcesFor(videoName)" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import AmbientVideo from '~/scopes/campaign/components/UI/AmbientVideo.vue'
import { useVideoSources } from '~/scopes/campaign/composables/useVideoSources'
import type { I18nDescriptor } from '~/scopes/campaign/data/metals/types'

defineProps<{
  body: I18nDescriptor
  /** Asset base name — the sources are resolved per locale at render. */
  videoName: string
}>()

const i18n = useI18n()
const { sourcesFor } = useVideoSources()
</script>
